import { SafeJSON } from './../../shared/safe-json';
import { Parent } from './../juvenile-case-sections/parent';
import { OtherAllegation } from './../juvenile-case-sections/other-allegations';

export class ProbationCondition {
    private json: any;
    private caseIssueId: string;
    private parents: any = [];
    private otherAllegations: any = [];

    private isOrderProbationConditionFlagPresent = false;
    private isConditionsProbationConditionFlagPresent = false;

    constructor(json: any, caseIssueId: string) {
        this.json = json;
        this.caseIssueId = caseIssueId;
        this.populateParents();
        this.populateOtherAllegations();
    }

    populateParents() {
        let obj: any = SafeJSON.get('parents', this.json);
        let index = '0';
        for (const issue of obj) {
            let value = new Parent(issue, index);
            this.parents.push(value);
        }
    }

    getParents(): any[] {
        this.parents.sort(function (parent1, parent2) {
            return parent1.getPartyName() === parent2.getPartyName() ? 0 : parent1.getPartyName() < parent2.getPartyName() ? -1 : 1;
        });
        return this.parents;
    }

    populateOtherAllegations() {
        let obj: any = SafeJSON.get('allegations', this.json);
        for (const otherAllegation of obj) {
            let allegationId: string = SafeJSON.get('allegationId', otherAllegation);
            if (allegationId !== this.caseIssueId) {
                let value = new OtherAllegation(otherAllegation);
                this.otherAllegations.push(value);
            }
        }
    }


    getOtherAllegations(): any[] {
        return this.otherAllegations;
    }

    getGoodBehaviour(): string {
        return SafeJSON.get('goodBehaviour', this.json);
    }

    getNotViolate(): string {
        return SafeJSON.get('notViolate', this.json);
    }

    getAttendSchool(): string {
        return SafeJSON.get('attendSchool', this.json);
    }

    getMaintainPassingGrades(): string {
        return SafeJSON.get('maintainPassingGrades', this.json);
    }

    getNumberOfCourses(): string {
        return SafeJSON.get('numberOfCourses', this.json);
    }

    getNotAssociateWithPersons(): string {
        return SafeJSON.get('notAssociateWithPersons', this.json);
    }

    getNotAssociatePersonsList(): string {
        return SafeJSON.get('notAssociatePersonsList', this.json);
    }

    getNotInPlaces(): string {
        return SafeJSON.get('notInPlaces', this.json);
    }

    getNotInPlacesList(): string {
        return SafeJSON.get('notInPlacesList', this.json);
    }

    getNotPossesControlledSubstance(): string {
        return SafeJSON.get('notPossesControlledSubstance', this.json);
    }

    getNotPossesAlcohol(): string {
        return SafeJSON.get('notPossesAlcohol', this.json);
    }

    getRandomTesting(): string {
        return SafeJSON.get('randomTesting', this.json);
    }

    getCurfew(): string {
        return SafeJSON.get('curfew', this.json);
    }

    getCurfewConditions(): string {
        return SafeJSON.get('curfewConditions', this.json);
    }

    getWarrentLessSearch(): string {
        return SafeJSON.get('warrentLessSearch', this.json);
    }

    getWarrentLessSearchConditions(): string {
        return SafeJSON.get('warrentLessSearchConditions', this.json);
    }

    getNoFirearm(): string {
        return SafeJSON.get('noFirearm', this.json);
    }

    getReportToCounselor(): string {
        return SafeJSON.get('reportToCounselor', this.json);
    }

    getPayRestitution(): string {
        return SafeJSON.get('payRestitution', this.json);
    }

    getPayRestitutionConditions(): string {
        return SafeJSON.get('payRestitutionConditions', this.json);
    }

    getPayFine(): string {
        return SafeJSON.get('payFine', this.json);
    }

    getPayFineConditions(): string {
        return SafeJSON.get('payFineConditions', this.json);
    }

    getBeEmployed(): string {
        return SafeJSON.get('curfew', this.json);
    }

    getOther(): string {
        return SafeJSON.get('curfew', this.json);
    }

    getOtherConditions(): string {
        return SafeJSON.get('otherConditions', this.json);
    }

    getCommunityService(): string {
        return SafeJSON.get('communityService', this.json);
    }

    getSubstanceAbuseMonitoring(): string {
        return SafeJSON.get('substanceAbuseMonitoring', this.json);
    }

    getLifeSkillsProgram(): string {
        return SafeJSON.get('lifeSkillsProgram', this.json);
    }

    getElectronicMonitoring(): string {
        return SafeJSON.get('electronicMonitoring', this.json);
    }

    getIntensiveSupervision(): string {
        return SafeJSON.get('intensiveSupervision', this.json);
    }

    getProbationTerminationDate(): string {
        return SafeJSON.get('probationTerminationDate', this.json);
    }

    isPrbnDataPresent(): boolean {
        let flag = false;

        if ((this.isConditionsDetailsPresent()) || (this.getOtherAllegations().length > 0) || (this.getParents().length > 0)) {
            flag = true;
        }

        return flag;
    }

    isConditionsDetailsPresent(): boolean {
        let flag = false;

        if ((this.getGoodBehaviour() !== '') || (this.getNotViolate() !== '') || (this.getAttendSchool() !== '') ||
            (this.getMaintainPassingGrades() !== '') || (this.getNumberOfCourses() !== '') || (this.getNotAssociateWithPersons() !== '') ||
            (this.getNotAssociatePersonsList() !== '') || (this.getNotInPlaces() !== '') || (this.getNotInPlacesList() !== '') ||
            (this.getNotPossesControlledSubstance() !== '') || (this.getNotPossesAlcohol() !== '') || (this.getRandomTesting() !== '') ||
            (this.getCurfew() !== '') || (this.getCurfewConditions() !== '') || (this.getWarrentLessSearch() !== '') ||
            (this.getWarrentLessSearchConditions() !== '') || (this.getNoFirearm() !== '') || (this.getReportToCounselor() !== '') ||
            (this.getPayRestitution() !== '') || (this.getPayRestitutionConditions() !== '') || (this.getPayFine() !== '') ||
            (this.getPayFineConditions() !== '') || (this.getBeEmployed() !== '') || (this.getOther() !== '') ||
            (this.getOtherConditions() !== '')) {
            flag = true;
        }
        return flag;
    }

    isOrderDetailsPresent(): boolean {
        let flag = false;
        if ((this.getCommunityService() !== '') || (this.getSubstanceAbuseMonitoring() !== '') || (this.getLifeSkillsProgram() !== '') ||
            (this.getElectronicMonitoring() !== '') || (this.getIntensiveSupervision() !== '') ||
            (this.getProbationTerminationDate() !== '')) {
            flag = true;
        }
        return flag;
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/probation-condition.ts